var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 121.8",
    style: {
      enableBackground: "new 0 0 110 121.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B7BCC7;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#B7BCC7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6,41.7H86V24.8c0-6.4-5.2-11.6-11.6-11.6H39.7v-1.7C39.7,5.2,34.5,0,28.1,0H11.6C5.2,0,0,5.2,0,11.6v49.6 c0,6.4,5.2,11.6,11.6,11.6h27.5V50.2C39.1,45.6,42.9,41.7,47.6,41.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.1,
    y: 77.4,
    className: "st1",
    width: 3.2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.3,68 49.1,67.5 49.1,73.2 52.3,73.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.3,59.1l-3-2.2c0,0-0.1,1.4-0.2,2.9c0,0.7-0.1,1.5-0.1,2.1c0,0.6,0,0.9,0,0.9l3.2,1.3V59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.3,106.1l-3.2,0.6c0,0,0,1.5,0,3c0,0.8,0,1.5,0,2.1c0,0.6,0,0.9,0,0.9l3.2-1.6V106.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.1,
    y: 96.7,
    className: "st1",
    width: 3.2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.1,
    y: 87.1,
    className: "st1",
    width: 3.2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7,
    y: 118.5,
    className: "st1",
    width: 5.4,
    height: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.8,118.5l-1.8,3.2c0,0,0.4,0,0.9,0c0.6,0,1.3,0,2.1,0c1.5,0,3,0,3,0l0.8-3.2H58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.3,115.1l-2.9,2.3c0,0,0,0.3,0.1,0.9c0,0.3,0,0.6,0.1,0.9c0.1,0.3,0.2,0.7,0.4,1c0.4,0.6,1.1,1,1.6,1.1 c0.3,0.1,0.5,0.1,0.6,0.1c0.1,0,0.2,0,0.2,0l2.4-2.8c0,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.6,0c-0.5-0.1-1-0.4-1.4-0.9 c-0.2-0.3-0.3-0.6-0.3-0.8c0-0.3,0-0.6,0-0.8C52.3,115.4,52.3,115.1,52.3,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.3,118.5l1,3.2c0,0,0.4,0,0.9,0c0.6,0,1.3,0,2.1,0c0.4,0,0.7,0,1.1,0c0.4,0,0.7,0,0.9,0 c0.6,0,0.9-0.1,0.9-0.1l-2-3.1H96.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "87,118.5 87,121.8 92.4,121.8 92.3,118.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.4,
    y: 118.5,
    className: "st1",
    width: 5.4,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.8,
    y: 95.8,
    className: "st1",
    width: 3.2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "106.8,110.2 110,111.7 110,105.6 106.8,105.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.3,118.4l2.4,2.7c0,0,0,0,0.1,0c0,0,0.1,0,0.2-0.1c0.1-0.1,0.3-0.2,0.6-0.3c0.4-0.3,0.9-1,1.1-1.6 c0.1-0.3,0.1-0.7,0.1-1c0-0.3,0.1-0.6,0.1-0.9c0-0.5,0.1-0.9,0.1-0.9l-3-2.1c0,0,0,0.3,0,0.8c0,0.2,0,0.5,0,0.8c0,0.3,0,0.6,0,0.9 c-0.1,0.6-0.5,1.2-0.8,1.4c-0.2,0.1-0.4,0.2-0.5,0.3C105.4,118.4,105.3,118.4,105.3,118.4C105.3,118.4,105.3,118.4,105.3,118.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.4,72.8l3-1.4c0,0,0-0.1-0.1-0.2c-0.1-0.1-0.3-0.3-0.4-0.5c-0.4-0.4-0.9-1-1.4-1.5 c-1.1-1.1-2.1-2.1-2.1-2.1l-2.4,2.2c0,0,0.9,0.9,1.8,1.8C105.6,71.9,106.5,72.8,106.4,72.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "106.8,81.9 110,81.9 110,76.1 106.8,76.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.8,
    y: 86.1,
    className: "st1",
    width: 3.2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86,54.9l0.8-3.2c0,0-0.4,0-0.9,0c-0.6,0-1.3,0-2.1,0c-1.4,0-2.8,0-2.8,0v3.2H86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.1,59.5l2.3-2.3l-2.5-2.5c-0.6-0.6-1.2-1.2-1.8-1.7L89.6,56l1.5,1.5L93.1,59.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 60.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -15.6733 88.6275)",
    className: "st1",
    width: 3.2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.1,54.9l-1.9-3.1c0,0-1.5,0.1-2.8,0.2c-0.3,0-0.7,0.1-1,0.1c-0.3,0-0.6,0.1-0.9,0.2 c-0.2,0.1-0.5,0.2-0.6,0.3c-0.1,0.1-0.2,0.1-0.2,0.1l2.5,2.6c0,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.2,0.5-0.2 c0.2-0.1,0.5-0.1,0.8-0.1c0.3,0,0.6,0,0.9,0C56.8,54.9,58.1,54.9,58.1,54.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67,54.9 66.9,51.7 60.9,51.7 62,54.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 51.7,
    className: "st1",
    width: 5.4,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.7,
    y: 76.1,
    className: "st1",
    width: 6.4,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 67.2,
    className: "st1",
    width: 3.2,
    height: 6.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "86.8,55.9 83.5,55.6 83.5,62.2 86.8,62.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.8,
    y: 75.4,
    className: "st1",
    width: 5.4,
    height: 3.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder);
export default __webpack_public_path__ + "static/media/empty-folder.fc3ebcbb0f6b0cd95604c476cdf170fd.svg";
export { ForwardRef as ReactComponent };